module.exports = "pegasus_template/assets/f-icon1.png";